import { Injectable } from '@angular/core';
import { Observable, fromEventPattern } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccelerometerService {

  constructor() { }

  getAcceleration(): Observable<DeviceMotionEventAcceleration> {
    return new Observable((observer) => {
      const handleAcceleration = (event: DeviceMotionEvent) => {
        if(event.acceleration)
        observer.next(event.acceleration);
      };

      window.addEventListener('devicemotion', handleAcceleration);

      // 返回取消訂閱函數
      return () => window.removeEventListener('devicemotion', handleAcceleration);
    });
  }
}
export class NavigatorService {
  constructor(private accelerometerService: AccelerometerService) {}

  getAccleration(): Promise<any> {
    // 加速
    //window.DeviceMotionEvent
    let acc: any = {};
    return acc;
  }
  async getCurrentPosition(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  }
  getGeolocation(): any {
    let geolocation = { lat: 24.13071, lng: 120.6367122 };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        geolocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        return geolocation;
      });
    }
    return geolocation;
  }

  async connectToBluetoothDevice() {
    try {
      // 步驟 2: 請求藍牙裝置
      const device = await (navigator as any).bluetooth.requestDevice({
        // 過濾條件，例如只顯示提供特定服務的裝置
        acceptAllDevices: true, // 這裡為了示例簡單化，接受所有裝置
        optionalServices: ['battery_service'], // 替換為你需要的服務UUID
      });

      // 步驟 3: 連接到藍牙裝置
      const server = await device.gatt.connect();

      // 獲取特定的服務
      const service = await server.getPrimaryService('battery_service'); // 替換為你需要的服務UUID

      // 獲取特定的特性
      const characteristic = await service.getCharacteristic('battery_level'); // 替換為你需要的特性UUID

      // 步驟 4: 讀取數據
      const value = await characteristic.readValue();
      const batteryLevel = value.getUint8(0);
      console.log(`Battery Level: ${batteryLevel}%`);
    } catch (error) {
      console.error('Bluetooth connection failed', error);
    }
  }
  async getBluetoothDevice() {
    let msg: string = '';
    try {
      const device = await (navigator as any).bluetooth.requestDevice({
        filters: [{ services: ['battery_service'] }],
      });

      const server = await device.gatt.connect();
      const service = await server.getPrimaryService('battery_service');
      const characteristic = await service.getCharacteristic('battery_level');

      characteristic.startNotifications().then((_: any) => {
        characteristic.addEventListener(
          'characteristicvaluechanged',
          this.handleCharacteristicValueChanged.bind(this)
        );
      });

      msg = 'Connected to ' + device.name;
    } catch (error) {
      console.error(error);
      msg = 'Error: ' + error;
    }
  }

  handleCharacteristicValueChanged(event: any) {
    let msg = '';
    const value = event.target.value;
    const batteryLevel = value.getUint8(0);
    msg += '\nBattery Level: ' + batteryLevel + '%';
  }
}
